import BaseListStore from 'stores/BaseListStore';
import RulePublishHistoryStore from 'stores/rule/RulePublishHistoryStore';
import { IDataFetchOptions } from '../../types';
import { get } from 'stores/_services/dataService';
import log from 'services/helpers/log';
import { SortDirection } from 'constants/SortDirection';

const SEARCH_FIELDS = ['name', 'short'];

export default class RulePublishHistoryListStore extends BaseListStore<RulePublishHistoryStore> {
    constructor() {
        super({
            itemStore: RulePublishHistoryStore
        });
    }

    async getPublishHistory(args: IDataFetchOptions): Promise<void> {
        this._updateListState(args);

        const options = {
            filter: {
                searchFields: SEARCH_FIELDS,
                order: this.sortBy === 'author' ? null : this.sort,
                includeFields: ['id', 'publishedBy', 'createdOn'],
                include: [
                    {
                        relation: 'author',
                        scope: {
                            fields: ['email']
                        }
                    }
                ]
            }
        };

        let res;

        try {
            res = await get('RulePublishHistory', options);
        } catch (e) {
            log.error(e as Error);
        }

        const { data } = res;

        this.clearIds();

        this._updateData(data);
        this._updateIds(data);

        if (this.sortBy === 'author') {
            const dir = this.sortDirection === SortDirection.ASC ? 1 : -1;

            this.ids.sort((a, b) => {
                const aData = this.data.get(a);
                const bData = this.data.get(b);

                return aData.author > bData.author ? dir : -dir;
            });
        }
    }

    async getRulePublishHistoryDetail(rulePublishHistoryId: string): Promise<void> {
        const options = {
            filter: {
                include: [
                    {
                        relation: 'author',
                        scope: {
                            fields: ['email']
                        }
                    }
                ]
            }
        };

        const { data } = await get(`RulePublishHistory/${rulePublishHistoryId}`, options);

        this._updateData(data);
    }

    async getRulePublishHistoryManifest(rulePublishHistoryId: string) {
        const { data } = await get(`RulePublishHistory/${rulePublishHistoryId}/getManifest`);
        this._updateData({ id: rulePublishHistoryId, publishHistoryManifest: data });
    }
}
